// @ts-ignore
import Vue from "vue";
// @ts-ignore
import AOS from 'aos';
import WorkbenchProducts from "../components/WorkbenchProducts/WorkbenchProducts";

namespace NHW.controllers.workbenchArticle {
	function initializeWorkbenchProducts() {
		if(document.getElementById('workbenchProducts')) {
			new Vue({
				created () {
					AOS.init({startEvent: 'load'})
				},
				render: h => h(WorkbenchProducts)
			}).$mount('#workbenchProducts');
		}
	}

	function initializeStepNavigation() {
			let steps:any = document.querySelectorAll(".js-step-container");
			let stepNav:any = document.querySelector('.js-step-nav-select');
			let stepNavElement:any = document.querySelector('.step-navigation');

			//abort this script if we dont have the navigation and the steps available to work with
			if(!steps.length) {
				return;
			}

			//the step navigation is hidden by default, reveal it if we have both steps
			//and a step nav elements on the page
			if(stepNavElement) {
				stepNavElement.classList.add('state-visible');
			}

			//loop through steps and set the placeholder label to be select option value

			steps.forEach((step:any, i) => {
				let navItem = document.createElement('option');
				let stepItem:any = step.querySelector("[data-sf-element='Step Title']");
				let stepText;
				let valueToCheck;
				if(stepItem) {
					stepText = stepItem.getAttribute('data-placeholder-label');
					valueToCheck = stepText;
				} else {
					stepText = "Undefined";
					valueToCheck = "Undefined";
				}

				navItem.innerHTML += valueToCheck;
				navItem.setAttribute('value', valueToCheck);

				if(stepNav) {
					stepNav.addEventListener('change',function(){
						let topOffset = step.offsetTop;
						if(this.value == valueToCheck){
							window.scrollTo({
								top:topOffset - 60,
								behavior:'smooth'
							});
						}
					});
					stepNav.appendChild(navItem);
				}
			});

	}

	export function init() {
		//Delay this function a bit to give time for the steps to load
		//seems to have trouble if we dont do this. could have something
		//to do with injecting them into the page in sitefinity
		setTimeout(function(){
			initializeStepNavigation();
		},500);
		initializeWorkbenchProducts();
	}
}

NHW.controllers.workbenchArticle.init();
